import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import InventoryPage from './pages/InventoryPage';
import ComboProductsPage from './pages/ComboProductsPage';
import FBAForecastPage from './pages/FBAForecastPage';
import ReorderPage from './pages/ReorderPage';
import UploadPage from './pages/UploadPage';
import DataManagementPage from './pages/DataManagementPage';
import AnalyticsPage from './pages/AnalyticsPage';
import SettingsPage from './pages/SettingsPage';
import SKUMappingPage from './pages/SKUMappingPage';
import SKUAnalysisPage from './pages/SKUAnalysisPage';
import LaunchTrackerPage from './pages/LaunchTrackerPage';
import UserManagementPage from './pages/UserManagementPage';
import DealRecommendationsPage from './pages/DealRecommendationsPage';
import '@/App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory"
        element={
          <ProtectedRoute>
            <InventoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/combos"
        element={
          <ProtectedRoute>
            <ComboProductsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/fba-forecast"
        element={
          <ProtectedRoute>
            <FBAForecastPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reorder"
        element={
          <ProtectedRoute>
            <ReorderPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/upload"
        element={
          <ProtectedRoute>
            <UploadPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/data-management"
        element={
          <ProtectedRoute>
            <DataManagementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/analytics"
        element={
          <ProtectedRoute>
            <AnalyticsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sku-mapping"
        element={
          <ProtectedRoute>
            <SKUMappingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sku-analysis"
        element={
          <ProtectedRoute>
            <SKUAnalysisPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/launch-tracker"
        element={
          <ProtectedRoute>
            <LaunchTrackerPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/deal-recommendations"
        element={
          <ProtectedRoute>
            <DealRecommendationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-management"
        element={
          <ProtectedRoute>
            <UserManagementPage />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;